import { render } from "./BlFormSubmit.vue?vue&type=template&id=2c593e2e"
import script from "./BlFormSubmit.vue?vue&type=script&lang=js"
export * from "./BlFormSubmit.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/6f278242-b890-433a-91e8-ee1cfc12c380/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__